import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Toggle } from '../../../../../../../../../../CommonComponents/OPL/Toggle/Toggle';
import { useAccountFormFieldDisabled } from '../../../../hooks/useCanEditLinkedAccountOwnerAndSync';

interface Props {
  isInsurance?: boolean;
}

export const SyncAccountValueToggle = ({ isInsurance }: Props) => {
  const fieldPrefix = isInsurance ? '' : 'bankAccount.';

  const formBag = useFormContext();
  const isFieldDisabled = useAccountFormFieldDisabled(true, {
    skipAccountFormProvider: isInsurance,
  });

  const showAccount = formBag.watch(`${fieldPrefix}ShowAccount`);

  return (
    <Toggle
      {...formBag.register(`${fieldPrefix}SyncAccountValueEnabled`)}
      size="small"
      disabled={isFieldDisabled || !showAccount}
    >
      Sync Account Value
    </Toggle>
  );
};
